"use strict";

var LoggerInstance = require("js-logger").get("EventSearchStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false,
	wizardEventSearch: {}
};

var EventSearchStore = class extends AbstractStore {
	constructor(dispatcher) {
		super();
		this.dispatchToken = dispatcher.register(action => {
			switch (action.actionType) {
				case Constants.EVENT_SEARCH_INITIALIZE:
					state.isDesignMode = action.isDesignMode;
					state.wizardEventSearch = action.wizardEventSearch;
					return true; // Don't emit change

				default:
					// no op
					return true;
			}

			this.emitChange();
			return true;
		});
	}

	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

module.exports = new EventSearchStore(Dispatcher);
